import React from "react";

import MenuSetting from "@/assets/images/svg/menu-setting.svg?react";
import MenuStorageReturn from "@/assets/images/svg/menu-storage-return.svg?react";
import MenuOrderCreate from "@/assets/images/svg/menu-order-create.svg?react";
import MenuStorageTransfer from "@/assets/images/svg/menu-storage-transfer.svg?react";
import MenuStorageComing from "@/assets/images/svg/menu-storage-coming.svg?react";
import MenuStorageWriteOff from "@/assets/images/svg/menu-storage-write-off.svg?react";
import MenuAnalytics from "@/assets/images/svg/menu-analiytics.svg?react";
import MenuFinance from "@/assets/images/svg/menu-finance.svg?react";
import MenuReport from "@/assets/images/svg/menu-report.svg?react";
import MenuHr from "@/assets/images/svg/menu-hr.svg?react";
import MenuStorage from "@/assets/images/svg/menu-storage.svg?react";
import MenuHandbook from "@/assets/images/svg/menu-handbook.svg?react";
import MenuAccounting from "@/assets/images/svg/menu-accounting.svg?react";
import ArrowRight from "@/assets/images/svg/arrow-right.svg?react";
import LogoutOutlined from "@/assets/images/svg/logout-outlined.svg?react";
import MenuOrder from "@/assets/images/svg/menu-order.svg?react";
import PrintIcon from "@/assets/images/icons/icon-printer.svg?react";
import LockIcon from "@/assets/images/svg/lock-icon.svg?react";
import MenuIdea from "@/assets/images/svg/menu-idea.svg?react";

const icons = {
  "menu-setting": MenuSetting,
  "menu-storage-write-off": MenuStorageWriteOff,
  "menu-order-create": MenuOrderCreate,
  "menu-storage-coming": MenuStorageComing,
  "menu-storage-transfer": MenuStorageTransfer,
  "menu-storage-return": MenuStorageReturn,
  "menu-analytic": MenuAnalytics,
  "menu-finance": MenuFinance,
  "menu-report": MenuReport,
  "menu-order": MenuOrder,
  "menu-hr": MenuHr,
  "menu-storage": MenuStorage,
  "menu-handbook": MenuHandbook,
  "menu-accounting": MenuAccounting,
  "lock-icon": LockIcon,
  "print-icon": PrintIcon,
  "arrow-right": ArrowRight,
  "logout-outlined": LogoutOutlined,
  "idea": MenuIdea,
};

export const Icon = ({ icon, ...restProps }) => {
  const SVG = icons[icon];

  return <SVG {...restProps} />;
};
